import React, { useState } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import {
  Main,
  Container,
  Header,
  Form,
  InputGroup,
  ErrorMessage,
  Button,
  LoginLink,
  LoadingSpinner,
} from "./RegisterPage/RegisterPage.styles";
import { findPassword } from "../api/userManagementAPI";

const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #fff;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateX(-2px);
  }

  &:before {
    content: "←";
    font-size: 16px;
  }
`;

export default function FindPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("이메일을 입력해주세요.");
      return;
    }

    if (!validateEmail(email)) {
      setError("올바른 이메일 형식을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await findPassword(email);

      setTimeout(() => {
        setIsLoading(false);
        setIsSuccess(true);
      }, 2000);
    } catch (error) {
      console.error("비밀번호 재설정 이메일 전송 실패:", error);
      setError("이메일 전송에 실패했습니다. 다시 시도해주세요.");
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    if (error) {
      setError("");
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Main>
      <BackButton onClick={handleBackClick}>뒤로가기</BackButton>

      <Container>
        <Header className="project-header">
          <h1>비밀번호 찾기</h1>
          <p>
            가입하신 이메일 주소를 입력하시면 비밀번호 재설정 링크를
            보내드립니다.
          </p>
        </Header>

        {isSuccess ? (
          <Form>
            <div style={{ textAlign: "center", padding: "40px 20px" }}>
              <h3 style={{ color: "#4CAF50", marginBottom: "20px" }}>
                이메일이 전송되었습니다!
              </h3>
              <p
                style={{ color: "rgba(255, 255, 255, 0.8)", lineHeight: "1.5" }}
              >
                입력하신 이메일 주소로 비밀번호 재설정 링크를 보내드렸습니다.
                <br />
                이메일을 확인하시고 링크를 클릭하여 비밀번호를 재설정해주세요.
              </p>
            </div>
          </Form>
        ) : (
          <Form onSubmit={handleSubmit}>
            <InputGroup error={error}>
              <label htmlFor="email">이메일 주소</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleInputChange}
                placeholder="example@email.com"
                disabled={isLoading}
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
            </InputGroup>

            <Button type="submit" disabled={!email || isLoading}>
              {isLoading ? (
                <>
                  <LoadingSpinner /> 전송중...
                </>
              ) : (
                "링크 전송"
              )}
            </Button>
          </Form>
        )}

        <LoginLink>
          <Link to="/login">로그인 페이지로 돌아가기</Link>
        </LoginLink>
      </Container>
    </Main>
  );
}
